<template>
  <div uk-height-viewport="offset-top: true" class="uk-flex uk-flex-center uk-flex-middle">
    <div
      class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-3@m uk-width-1-1 uk-margin-small"
    >
      <h2 class="uk-margin-small">Request Submitted</h2>
      <p>Your design request has been submitted! Our design team will be sending over your designs soon.</p>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import router from "@/router";

export default {
  name: "OrgSubmitted",
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-onboarding/OrgSubmitted.vue